import { setGlobalSessionId } from "@/services";
import { storageUtils } from "@/utils/storage";
import { Platform } from "react-native";

import { create } from "zustand";

interface AppState {
  isInitialized: boolean;
  hasSession: boolean;
  initData?: {
    route: string;
    params?: Record<string, string | string[] | undefined>;
  };
  setIsInitialized: (isInitialized: boolean) => void;
  setHasSession: (hasSession: boolean) => void;
  init: ({
    sessionId,
    initData,
  }: {
    sessionId?: string;
    initData?: {
      route: string;
      params?: Record<string, string | string[] | undefined>;
    };
  }) => Promise<void>;
}

const useAppStore = create<AppState>((set) => ({
  isInitialized: false,
  hasSession: false,
  initData: undefined,
  setIsInitialized: (isInitialized) => set({ isInitialized }),
  setHasSession: (hasSession) => set({ hasSession }),
  init: async (opts) => {
    try {
      if (opts.initData) {
        set({ initData: opts.initData });
      }
      // Restore session from storage
      const getSessionId = Platform.select({
        web: () => opts.sessionId || storageUtils.getSessionId(),
        default: () => storageUtils.getSessionId(),
      });

      const storedSessionId = getSessionId();

      if (storedSessionId) {
        storageUtils.setSessionId(storedSessionId);
        setGlobalSessionId(storedSessionId);
        set({ hasSession: true });
        console.log("📱 Session restored from storage");
      } else {
        console.log("📱 No stored session found");
      }
    } catch (error) {
      console.error("❌ App initialization error:", error);
    } finally {
      setTimeout(() => {
        set({ isInitialized: true });
      }, 1000);
    }
  },
}));

export default useAppStore;
